import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import Tooltip from '../../../app/frame/shared/tooltip';
import { useIsBigScreen } from '../../../../../customHooks/useIsBigScreen';
import {
  useActivateInteractiveModules,
  useChartColors,
  useDeactivateMenu,
  useFileDetails,
  useHasAccountRestrictions,
  useHasBasicConfig,
  useLastPageStore,
  useMenuBar,
  useNavigationMenu,
  useNewLillyClaim,
  useOpenCustomChartColors,
  useReportsMenuWithAllExcluded,
  useSetGenericError,
  useShowChartLabel,
  useShowManageAccount,
  useShowsModalError,
  useTrialExpired,
  useWorkspaceStore
} from '../../../../../lib/store/v3/layout';
import {
  clearReportsSelection,
  fixAndParseInvalidJson,
  FreePrice,
  FreePriceTest,
  getLocalStorage,
  getWorkspace,
  handleOpenEmail,
  setLocalStorage
} from '../../../../../utils';
import {
  useAccountHasFreePlan,
  useAccountHasPlanPaid,
  useAccountHasStarterPlan,
  useAccountHasTrialPlanPaid
} from '../../../../../lib/store/dashboard.store';
import { useMutation } from 'react-query';
import { useAuth } from '../../../../../../../scripts/fb';
import axios from 'axios';
import { useColumnView } from '../../../../../lib/store/settings.store';
import {
  useAccountHasLillyPaid,
  useClearSelectionReports,
  useForceReportsShowLess,
  useForceReportsShowMore,
  useLoaderMenuStore,
  useMajorReportsCheckboxView,
  useSearchTextStoreReports,
  useSortMenuReportsValues,
  useValueSearchTextBox
} from '../../../../../lib/store/frame.store';
import { Userpilot } from 'userpilot';
import {
  useAccordionUI,
  useAIExplainerReports,
  useAIExplainerReportsArray,
  useBreakDownData,
  useBreakDownSelected,
  useChartCalculationReports,
  useChartSelected,
  useCounter,
  useDistributionStore,
  useFiltersData,
  useFiltersViewsOpened,
  useHideCountsButtons,
  useLastDataWithShowMoreNoFilters,
  useRationIconReports,
  useReportsData,
  useReportsDateFormatData,
  useReportsReqAIExplainer,
  useReportsViewsData,
  useScrollDownGrid,
  useSelectAndNonAllValuesView,
  useShowAIExplainerReports,
  useShowMoreClicks,
  useTabSelected,
  useTypeCalculationChartSelected,
  useTypeDateChartSelected,
  useUnfilteredData,
  useUnfilteredToggleStatus,
  useViewSelected
} from '../../../../../lib/store/reports.store';
import {
  use360AnalysisCounter,
  use360AnalysisFilters,
  use360ComparisonCounter,
  use360ComparisonFilters,
  use360ViewsData,
  useAnalysisFilterClicked,
  useComparisonStore,
  useFilters360Box,
  useFiltersComparisonBox
} from '../../../../../lib/store/360.store';
import {
  useAccordionUICluster,
  useClearSelectionClicked,
  useClusterButtonGoStatus,
  useClusterCounter,
  useClusterViewsData,
  usePredictiveStore
} from '../../../../../lib/store/cluster.store';
import { EchartOption } from '../../../../../enums';
import {
  useAccordionUICorrelation,
  useCorrelationCounter,
  useCorrelationRowsGrid,
  useCorrelationStore,
  useCorrelationViewsData
} from '../../../../../lib/store/correlation.store';
import {
  useControlTowerData,
  useMyViewsControlTower
} from '../../../../../lib/store/control-tower.store';

export const MenuSidebar = () => {
  const location = useLocation().pathname;
  const navigate = useNavigate();
  const isBigScreen = useIsBigScreen();
  const activateInteractiveM = useActivateInteractiveModules((state: any) => state.activate);
  const setActivateInteractiveM = useActivateInteractiveModules((state: any) => state.setActivate);
  const navigation = useNavigationMenu((state: any) => state.navigation);
  const setNavigation = useNavigationMenu((state: any) => state.setNavigation);
  const openMenu = useMenuBar((state: any) => state.openMenu);
  const setOpenMenu = useMenuBar((state: any) => state.setOpenMenu);
  const currentWorkspace = useWorkspaceStore((state) => state.currentWorkspace);
  const setCurrentWorkspace = useWorkspaceStore((state) => state.setCurrentWorkspace);
  const accountPaidDashboard = useAccountHasPlanPaid((state: any) => state.accountPaid);
  const starterAccount = useAccountHasStarterPlan((state: any) => state.accountPaid);
  const trialAccountPaid = useAccountHasTrialPlanPaid((state: any) => state.trialAccountPaid);
  const setLastPage = useLastPageStore((state) => state.setLastPage);
  const auth = useAuth();
  const freeAccount = useAccountHasFreePlan((state: any) => state.freeAccount);
  const trialExpired = useTrialExpired((state: any) => state.trialExpired) && !freeAccount;
  const setShowModalError = useShowsModalError((state: any) => state.setShowModalError);
  const setHasRestrictions = useHasAccountRestrictions((state: any) => state.setHasRestrictions);
  const setColumnView = useColumnView((state: any) => state.updateView);
  const accountLillyPaid = useAccountHasLillyPaid((state: any) => state.accountPaid);
  const fileSelected = useFileDetails((state: any) => state.fileSelected);
  const [isLillyFile, setIsLillyFile] = useState(false);
  const showStripeLink = useShowManageAccount((state: any) => state.showStripeLink);
  const newLillyClaim = useNewLillyClaim((state: any) => state.newLillyClaim);
  const showModalError = useShowsModalError((state: any) => state.showModalError);
  const setDistributionRequestAIChat = useDistributionStore((state) => state.setDistribution);
  const clearDistribution = useDistributionStore((state) => state.clearDistribution);
  const setComparisonRequestAIChat = useComparisonStore((state) => state.setComparison);
  const clearComparison = useComparisonStore((state) => state.clearComparison);
  const comparisonAIChat = useComparisonStore((state) => state.comparison);
  const setPctAnalysisCounter = use360AnalysisCounter((state: any) => state.setPctCounter);
  const setPctComparisonCounter = use360ComparisonCounter((state: any) => state.setPctCounter);
  const setIsAnalyzeFiltersClicked = useAnalysisFilterClicked((state: any) => state.setIsClicked);
  const setIsClusterBtnClicked = useClusterButtonGoStatus((state: any) => state.setIsClicked);
  const setFilters = use360AnalysisFilters((state: any) => state.setFilters);
  const setAnalyzeFilters = useFilters360Box((state: any) => state.setFilters);
  const setComparisonFilters = use360ComparisonFilters((state: any) => state.setFilters);
  const setComparisonFiltersBox = useFiltersComparisonBox((state: any) => state.setFilters);
  const view360Data = use360ViewsData((state: any) => state.viewDataSelected);
  const setView360Data = use360ViewsData((state: any) => state.setViewDataSelected);
  const distributionRequestAIChat = useDistributionStore((state) => state.distribution);
  const setCounter = useCounter((state: any) => state.setCounter);
  const viewData = useReportsViewsData((state: any) => state.viewData);
  const setViewData = useReportsViewsData((state: any) => state.setViewData);
  const setAccordionInfo = useAccordionUI((state: any) => state.setAccordion);
  const setReportsData = useReportsData((state: any) => state.setReportsData);
  const setDateReportsData = useReportsDateFormatData((state: any) => state.setDateReportsData);
  const setChartCalculationSelected = useChartCalculationReports(
    (state: any) => state.setChartCalculationSelected
  );
  const setBreakDownData = useBreakDownData((state: any) => state.setBreakDownData);
  const setType = useTypeCalculationChartSelected((state: any) => state.setType);
  const setBreakDownSelected = useBreakDownSelected((state: any) => state.setBreakDownSelected);
  const setViewSelected = useViewSelected((state: any) => state.setViewSelected);
  const setChartSelected = useChartSelected((state: any) => state.setChartSelected);
  const correlationsRequestAIChat = useCorrelationStore((state) => state.correlations);
  const setCorrelationsRequestAIChat = useCorrelationStore((state) => state.setCorrelations);
  const clearCorrelations = useCorrelationStore((state) => state.clearCorrelations);
  const viewCorrelationData = useCorrelationViewsData((state: any) => state.viewDataSelected);
  const setViewCorrelationData = useCorrelationViewsData((state: any) => state.setViewDataSelected);
  const setAccordionInfoCorrelation = useAccordionUICorrelation((state: any) => state.setAccordion);
  const setCorrelationsRowsAgGrid = useCorrelationRowsGrid((state: any) => state.setRowsAgGrid);
  const setCorrelationsCounter = useCorrelationCounter((state: any) => state.setCounter);

  const predictiveRequestAIChat = usePredictiveStore((state) => state.predictive);
  const setPredictiveRequestAIChat = usePredictiveStore((state) => state.setPredictive);
  const clearPredictive = usePredictiveStore((state) => state.clearPredictive);
  const viewPredictiveDataSelected = useClusterViewsData((state: any) => state.viewDataSelected);
  const setPredictiveViewDataSelected = useClusterViewsData(
    (state: any) => state.setViewDataSelected
  );
  const setPredictiveCounter = useClusterCounter((state: any) => state.setCounter);
  const setAccordionInfoCluster = useAccordionUICluster((state: any) => state.setAccordion);
  const deactivateMenu = useDeactivateMenu((state: any) => state.deactivate);
  const clearMyMenuLoader = useLoaderMenuStore((state: any) => state.clearMyLoader);
  const setBasicConfig = useHasBasicConfig((state: any) => state.setConfig);
  const setIsOpenChartSettins = useOpenCustomChartColors((state: any) => state.setShowColors);
  const isChartSettingsOpen = useOpenCustomChartColors((state: any) => state.showColors);
  const setThemeColors = useChartColors((state: any) => state.setColors);
  const setShowCounters = useShowChartLabel((state: any) => state.setShowLabels);
  const basicChartConfig = useHasBasicConfig((state: any) => state.config);
  const setMyViewsControlTowerData = useMyViewsControlTower((state: any) => state.setData);
  const setReports = useControlTowerData((state: any) => state.setData);

  // Additional hooks needed for clearReportsSelection
  const setCheckboxReportsViewArr = useMajorReportsCheckboxView((state: any) => state.setCheckbox);
  const setSortMenuReportsValuesData = useSortMenuReportsValues((state: any) => state.setSortData);
  const setForceReportsShowLess = useForceReportsShowLess((state: any) => state.setForce);
  const setForceReportsShowMore = useForceReportsShowMore((state: any) => state.setForce);
  const setClearSelectionReports = useClearSelectionReports((state: any) => state.setIsClear);
  const setTextStoreReports = useSearchTextStoreReports((state: any) => state.setText);
  const setHideCountsBtn = useHideCountsButtons((state: any) => state.setHideCountsBtn);
  const setChartRatioSelected = useRationIconReports((state: any) => state.setChartRatioSelected);
  const setShowExplainerReports = useShowAIExplainerReports((state: any) => state.setShowExplainer);
  const setExplainerReports = useAIExplainerReports((state: any) => state.setExplainer);
  const setExplainerReportsArray = useAIExplainerReportsArray((state: any) => state.setExplainer);
  const setValueSearchBox = useValueSearchTextBox((state: any) => state.setValue);
  const setClicksDataShowMore = useShowMoreClicks((state: any) => state.setNumberClicks);
  const setScrollDownData = useScrollDownGrid((state: any) => state.setScrollDown);
  const setLastDataWithNoFilters = useLastDataWithShowMoreNoFilters(
    (state: any) => state.setDataClean
  );
  const setViewsAllNonSelected = useSelectAndNonAllValuesView((state: any) => state.setViews);
  const setUnfilteredToggleStatus = useUnfilteredToggleStatus(
    (state: any) => state.setUnfilteredToggleStatus
  );
  const setUnfilterdata = useUnfilteredData((state: any) => state.setUnfilterdata);
  const setTypeDateSelected = useTypeDateChartSelected((state: any) => state.setTypeDate);
  const setFiltersData = useFiltersData((state: any) => state.setFiltersData);
  const setTabTypeSelected = useTabSelected((state: any) => state.setTabSelected);
  const setViewsOpened = useFiltersViewsOpened((state: any) => state.setViewsOpened);
  const setClearClusterData = useClearSelectionClicked((state: any) => state.setClearData);
  const setReportsRequest = useReportsReqAIExplainer((state: any) => state.setRequest);
  const clearMyLoader = useLoaderMenuStore((state: any) => state.clearMyLoader);

  useEffect(() => {
    const path = window.location.pathname;
    const workspaceid = getWorkspace(location);
    let objAIChatFilters;
    const params = new URLSearchParams(window.location.search);
    let rawJson = params.get('json') || '';
    if (rawJson.length > 0) {
      rawJson = decodeURIComponent(rawJson);
      if (rawJson.startsWith('"') && rawJson.endsWith('"')) {
        rawJson = rawJson.slice(1, -1);
      }
      const jsonString = rawJson.replace(/'/g, '"');
      let jsonObject: any = {};
      jsonObject = fixAndParseInvalidJson(jsonString);
      if (path.includes('/distributions')) {
        objAIChatFilters = { fields: jsonObject.fields, filter: jsonObject?.filter || [] };
        localStorage.removeItem('hasProcessedCounterReportsAIChat');
      } else if (path.includes('/comparative')) {
        objAIChatFilters = jsonObject.filters;
        localStorage.removeItem('hasProcessedComparisonAIChat');
        localStorage.removeItem('hasProcessedAnalysisAIChat');
        localStorage.removeItem('hasProcessedComparisonFiltersAIChat');
        setLocalStorage('comesComparsionFromAIChat', true);
      } else if (path.includes('/predictive')) {
        localStorage.removeItem('hasProcessedPredictiveAIChat');
        objAIChatFilters = { target: jsonObject.target };
      } else if (path.includes('/correlations')) {
        localStorage.removeItem('hasProcessedCorrelationsAIChat');
        objAIChatFilters = jsonObject?.filters || [];
      }
    } else objAIChatFilters = null;

    if (typeof path === 'string') {
      const pageByDefault = path.includes('/new_file');
      const workspaceIdFromEmail = getLocalStorage('workspaceIdFromEmail');
      const sharedViewfromEmail = getLocalStorage('sharedViewfromEmail');
      const comesFromShareViewEmail = pageByDefault && workspaceIdFromEmail && sharedViewfromEmail;
      const workspace = workspaceid || workspaceIdFromEmail;
      if ((path.includes('/chat') || comesFromShareViewEmail) && workspace) {
        setActivateInteractiveM(true);
        setNavigation('ai-chat');
        setOpenMenu(true);
        Userpilot.track('ai_analyst_page');
        setCurrentWorkspace(workspaceid);
        navigate(`/chat/${workspace}`);
        if (comesFromShareViewEmail) {
          localStorage.removeItem('workspaceIdFromEmail');
          localStorage.removeItem('sharedViewfromEmail');
        }
      } else if (path.includes('/distributions')) {
        if (objAIChatFilters) setDistributionRequestAIChat(objAIChatFilters);
        if (!objAIChatFilters) localStorage.removeItem('hasProcessedCounterReportsAIChat');
        setActivateInteractiveM(true);
        setNavigation('distributions');
        setOpenMenu(true);
        Userpilot.track('nav_bar_distribution');
        setCurrentWorkspace(workspaceid);
        navigate(`/distributions/${workspaceid}`);
      } else if (path.includes('/control-tower')) {
        setActivateInteractiveM(true);
        setNavigation('control-tower');
        setOpenMenu(true);
        setCurrentWorkspace(workspaceid);
        navigate(`/control-tower/${workspaceid}`);
      } else if (path.includes('/comparative')) {
        if (objAIChatFilters) setComparisonRequestAIChat(objAIChatFilters);
        setActivateInteractiveM(true);
        setNavigation('comparative');
        setOpenMenu(true);
        Userpilot.track('nav_bar_comparative');
        setCurrentWorkspace(workspaceid);
        navigate(`/comparative/${workspaceid}`);
      } else if (path.includes('/predictive')) {
        if (objAIChatFilters) setPredictiveRequestAIChat(objAIChatFilters);
        if (!objAIChatFilters) localStorage.removeItem('hasProcessedPredictiveAIChat');
        setActivateInteractiveM(true);
        setNavigation('predictive');
        setOpenMenu(true);
        Userpilot.track('nav_bar_predictive');
        setCurrentWorkspace(workspaceid);
        navigate(`/predictive/${workspaceid}`);
      } else if (path.includes('/configuration')) {
        setActivateInteractiveM(true);
        setNavigation('configuration');
        setOpenMenu(true);
        Userpilot.track('nav_bar_settings');
        setCurrentWorkspace(workspaceid);
        navigate(`/configuration/${workspaceid}`);
      } else if (path.includes('/dashboards')) {
        setActivateInteractiveM(true);
        setNavigation('dashboards');
        setOpenMenu(true);
        Userpilot.track('nav_bar_my_dashboards');
        setCurrentWorkspace(workspaceid);
        navigate(`/dashboards/${workspaceid}`);
      } else if (path.includes('/exploratory')) {
        setActivateInteractiveM(true);
        setNavigation('exploratory');
        setOpenMenu(true);
        Userpilot.track('nav_bar_exploratory');
        setCurrentWorkspace(workspaceid);
        navigate(`/exploratory/${workspaceid}`);
      } else if (path.includes('/trends')) {
        setActivateInteractiveM(true);
        setNavigation('trends');
        setOpenMenu(true);
        setCurrentWorkspace(workspaceid);
        navigate(`/trends/${workspaceid}`);
      } else if (path.includes('/correlations')) {
        if (objAIChatFilters) setCorrelationsRequestAIChat(objAIChatFilters);
        if (!objAIChatFilters) localStorage.removeItem('hasProcessedCorrelationsAIChat');
        setActivateInteractiveM(true);
        setNavigation('correlations');
        setOpenMenu(true);
        Userpilot.track('nav_bar_correlation');
        setCurrentWorkspace(workspaceid);
        navigate(`/correlations/${workspaceid}`);
      } else if (path.includes('/files')) {
        navigate('/files');
        setOpenMenu(true);
        setNavigation('my-files');
      } else if (path.includes('/connectors')) {
        navigate('/connectors');
        setOpenMenu(true);
        setNavigation('data-connectors');
        Userpilot.track('nav_bar_data_import');
      } else if (path.includes('/faqs')) {
        navigate('/faqs');
        setNavigation('faqs');
        Userpilot.track('nav_bar_faq');
      } else if (path.includes('/upgrade')) {
        navigate('/upgrade');
        setNavigation('upgrade');
        setOpenMenu(true);
        Userpilot.track('upgrade_button');
      }
    }
  }, [auth, auth?.user]);

  const onClickNavigation = (option: string) => {
    if (showModalError) {
      setShowModalError(false);
    }
    const domain = window.location.origin;
    const isUat = domain.includes('uat') || domain.includes('localhost') ? true : false;
    setColumnView('empty');
    clearMyMenuLoader();
    if ((freeAccount || starterAccount) && option == 'dashboards') {
      setShowModalError(true);
      setHasRestrictions(true);
    } else {
      setIsAnalyzeFiltersClicked(false);
      if (comparisonAIChat && comparisonAIChat?.filters?.length > 0) {
        clearComparison();
        setFilters([]);
        setAnalyzeFilters([]);
        setComparisonFilters([]);
        setComparisonFiltersBox([]);
        setPctComparisonCounter(null);
        setPctAnalysisCounter(null);
        view360Data?.forEach((element) => {
          element.values = [];
          element.backupValues = [];
          element.sort = 'asc';
        });
        setView360Data(view360Data);
      }
      if (distributionRequestAIChat && distributionRequestAIChat?.fields?.length > 0) {
        clearDistribution();
        viewData?.forEach((element) => {
          element.values = [];
          element.sort = 'asc';
          element.expanded = false;
        });
        setViewData(viewData);
        setAccordionInfo([]);
        setReportsData(null);
        setDateReportsData(undefined);
        setChartCalculationSelected(EchartOption.COUNT);
        setBreakDownData(null);
        setType(EchartOption.COUNT);
        setBreakDownSelected(null);
        setViewSelected(null);
        setChartSelected(EchartOption.GRID);
        setCounter(0);
      }
      if (correlationsRequestAIChat && correlationsRequestAIChat?.filters?.length > 0) {
        clearCorrelations();
        viewCorrelationData?.forEach((element) => {
          element.values = [];
          element.sort = 'asc';
          element.expanded = false;
        });
        setViewCorrelationData(viewCorrelationData);
        setAccordionInfoCorrelation([]);
        setCorrelationsRowsAgGrid([]);
        setCorrelationsCounter(0);
      }

      if (predictiveRequestAIChat && Object.keys(predictiveRequestAIChat?.target).length > 0) {
        clearPredictive();
        viewPredictiveDataSelected?.forEach((element) => {
          element.values = [];
          element.sort = 'asc';
          element.expanded = false;
        });
        setPredictiveViewDataSelected(viewPredictiveDataSelected);
        setAccordionInfoCluster(null);
        setPredictiveCounter(0);
      }

      localStorage.removeItem('hasProcessedCounterReportsAIChat');
      localStorage.removeItem('hasProcessedCorrelationsAIChat');
      localStorage.removeItem('hasProcessedPredictiveAIChat');

      let workspaceid = getWorkspace(location);
      // const isFAQsPage = location.includes('faqs');
      if (currentWorkspace && currentWorkspace?.length > 0) {
        workspaceid = currentWorkspace;
      }
      setNavigation(option);
      if (
        isChartSettingsOpen &&
        option != 'my-files' &&
        basicChartConfig &&
        basicChartConfig.chartConfig
      ) {
        setThemeColors(basicChartConfig.chartConfig.themeColors);
        setShowCounters(basicChartConfig.chartConfig.showCounters);
      }

      if (option == 'my-files') {
        navigate('/files');
        setIsOpenChartSettins(false);
        setOpenMenu(true);
        setIsClusterBtnClicked(false);
        setActivateInteractiveM(false);
        setBasicConfig(null);
        setMyViewsControlTowerData([]);
        setReports([]);
      } else if (option == 'new-file') {
        localStorage.removeItem('workspaceIdFromEmail');
        localStorage.removeItem('sharedViewfromEmail');
        Userpilot.track('add_data_button');
        setOpenMenu(true);
        navigate('/new_file');
        // setActivateInteractiveM(false);
      } else if (option == 'ai-chat' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('ai_analyst_page');
        navigate(`/chat/${workspaceid}`);
      } else if (option == 'distributions' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('nav_bar_distribution');
        navigate(`/distributions/${workspaceid}`);
      } else if (option == 'control-tower' && workspaceid) {
        // Clear all selection states before navigating to Control Tower
        clearReportsSelection({
          clearMyLoader,
          setAccordionInfo,
          setReportsData,
          setReportsRequest,
          setDateReportsData,
          setCheckboxReportsViewArr,
          setSortMenuReportsValuesData,
          setForceReportsShowLess,
          setForceReportsShowMore,
          setClearSelectionReports,
          setTextStoreReports,
          setChartCalculationSelected,
          setHideCountsBtn,
          setChartRatioSelected,
          setShowExplainerReports,
          setExplainerReports,
          setExplainerReportsArray,
          setValueSearchBox,
          setClicksDataShowMore,
          setScrollDownData,
          setLastDataWithNoFilters,
          setViewsAllNonSelected,
          setUnfilteredToggleStatus,
          setBreakDownData,
          setUnfilterdata,
          setType,
          setTypeDateSelected,
          setFiltersData,
          setBreakDownSelected,
          setViewSelected,
          setChartSelected,
          setTabTypeSelected,
          setViewsOpened,
          setClearClusterData,
          viewData,
          getCounterData: undefined, // Not needed for navigation clear
          location
        });

        setOpenMenu(true);
        // Userpilot.track('nav_bar_distribution');
        navigate(`/control-tower/${workspaceid}`);
      } else if (option == 'comparative' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('nav_bar_comparative');
        navigate(`/comparative/${workspaceid}`);
      } else if (option == 'predictive' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('nav_bar_predictive');
        navigate(`/predictive/${workspaceid}`);
      } else if (option == 'configuration' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('nav_bar_settings');
        navigate(`/configuration/${workspaceid}`);
      } else if (option == 'dashboards' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('nav_bar_my_dashboards');
        navigate(`/dashboards/${workspaceid}`);
      } else if (option == 'exploratory' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('nav_bar_exploratory');
        navigate(`/exploratory/${workspaceid}`);
      } else if (option == 'trends' && workspaceid) {
        setOpenMenu(true);
        navigate(`/trends/${workspaceid}`);
      } else if (option == 'correlations' && workspaceid) {
        setOpenMenu(true);
        Userpilot.track('nav_bar_correlation');
        navigate(`/correlations/${workspaceid}`);
      } else if (option == 'faqs') {
        Userpilot.track('nav_bar_faq');
        navigate('/faqs');
      } else if (option == 'data-connectors') {
        setOpenMenu(true);
        Userpilot.track('nav_bar_data_import');
        navigate('/connectors');
      } else if (option == 'upgrade') {
        setLastPage('');
        setOpenMenu(true);
        Userpilot.track('upgrade_button');
        navigate('/upgrade');
      }
    }
  };

  useEffect(() => {
    if (fileSelected?.name) {
      const isLilly =
        fileSelected?.name == 'Lilly_Main' ||
        fileSelected?.name == 'Lilly_Positive_Feedback' ||
        fileSelected?.name == 'Lilly_Improvement_Feedback' ||
        fileSelected?.name == 'Lilly_Suggestions';
      setIsLillyFile(isLilly);
    }
  }, [fileSelected, fileSelected?.name]);

  return (
    <div
      className={`${
        (comparisonAIChat && comparisonAIChat?.filters?.length > 0) ||
        (distributionRequestAIChat && distributionRequestAIChat?.fields?.length > 0) ||
        (correlationsRequestAIChat && correlationsRequestAIChat?.filters?.length > 0) ||
        (predictiveRequestAIChat && Object.keys(predictiveRequestAIChat?.target).length > 0)
          ? 'hidden'
          : ''
      } ${
        openMenu ? 'w-[70px] max-w-[70px] min-w-[70px]' : 'w-[244px] max-w-[244px] min-w-[244px] '
      } ${
        deactivateMenu ? 'pointer-events-none' : ''
      } h-screen bg-[#F5F5F580] shadow-md flex flex-col border-[1px] border-solid border-[#DAE0E9]`}>
      <div
        className={`${
          openMenu ? 'justify-center px-2 pb-[19px] pt-4' : 'justify-between p-4'
        } flex items-center align-middle w-full mt-0 mb-[3px]`}>
        <div className="flex items-center">
          <a
            className="flex items-center"
            href="https://www.drumroll.ai/"
            target="_blank"
            rel="noreferrer">
            <img
              src={`${openMenu ? '/icons/v3/short-logo.svg' : '/icons/v3/full-logo.svg'}`}
              alt="Drumroll Logo"
              className={`${!isBigScreen ? 'h-5' : ''}`}
            />
          </a>
        </div>
        <div className="cursor-pointer" onClick={() => setOpenMenu(!openMenu)}>
          <img
            src={`${openMenu ? '/icons/v3/open-panel.svg' : '/icons/v3/close-panel.svg'}`}
            className="ml-1"
            alt=""
          />
        </div>
      </div>

      {/* Navigation */}
      <div className={`${isBigScreen ? 'mb-4' : 'mb-2.5'} flex flex-col`}>
        <Tooltip
          content="New file"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[5.4rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('new-file')}
            className={`${navigation == 'new-file' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-5'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4 ${trialExpired ? 'pointer-events-none opacity-50' : ''}`}>
            <img
              src="/icons/v3/new-file.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                New file
              </span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="My files"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[5.3rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('my-files')}
            className={`${navigation == 'my-files' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-5'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4 ${trialExpired ? 'pointer-events-none opacity-50' : ''}`}>
            <img
              src="/icons/v3/my-files.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                My files
              </span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="Data Import"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6.45rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('data-connectors')}
            className={`${navigation == 'data-connectors' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-5'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4 ${trialExpired ? 'pointer-events-none opacity-50' : ''}`}>
            <img
              src="/icons/v3/data-connectors.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Data Import
              </span>
            )}
          </div>
        </Tooltip>
      </div>

      <div
        className={`${
          !activateInteractiveM ? 'opacity-70' : ''
        } border-b my-0.5 mx-3 border-[#788AA6]`}></div>

      <Tooltip
        content="AI Chat"
        direction="right"
        class={`${!openMenu ? 'hidden' : 'ml-[5.4rem]'}`}
        menu={true}>
        <div
          onClick={() => onClickNavigation('ai-chat')}
          className={`${navigation == 'ai-chat' ? 'bg-[#788AA61F]' : ''} ${
            openMenu ? 'justify-center' : 'pl-5'
          } cursor-pointer hover:bg-[#788AA61F] ${
            isBigScreen ? 'py-3.5' : 'py-2'
          } flex items-center gap-4 ${
            !activateInteractiveM ? 'opacity-50 pointer-events-none' : ''
          }`}>
          <img src="/icons/v3/chat.svg" className={`${!isBigScreen ? 'h-[17px]' : ''}`} alt="" />
          {!openMenu && (
            <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>AI Chat</span>
          )}
        </div>
      </Tooltip>

      <div
        className={`${
          !activateInteractiveM ? 'opacity-70' : ''
        } border-b mx-3 my-1 border-[#788AA6]`}></div>

      {/* Interactive Modules */}

      <div
        className={`${!openMenu ? 'pt-2' : 'invisible -mt-3'} font-semibold ${
          isBigScreen ? 'text-sm' : 'text-xs'
        } pl-5 opacity-50`}>
        Interactive Modules
      </div>

      <div
        className={`${!activateInteractiveM ? 'pointer-events-none opacity-40' : ''} ${
          isBigScreen ? 'mt-4' : 'mt-2.5'
        } flex flex-col mb-1`}>
        {accountLillyPaid && isLillyFile && (
          <Tooltip
            content="Trends"
            direction="right"
            class={`${!openMenu ? 'hidden' : 'ml-[6.15rem]'}`}
            menu={true}>
            <div
              onClick={() => onClickNavigation('trends')}
              className={`${navigation == 'trends' ? 'bg-[#788AA61F]' : ''} ${
                openMenu ? 'justify-center' : 'pl-11'
              } cursor-pointer hover:bg-[#788AA61F] ${
                isBigScreen ? 'py-3.5' : 'py-2'
              } flex items-center gap-4`}>
              <img
                src="/icons/v3/trends.svg"
                className={`${!isBigScreen ? 'h-[17px]' : ''}`}
                alt=""
              />
              {!openMenu && (
                <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                  Trends
                </span>
              )}
            </div>
          </Tooltip>
        )}

        <Tooltip
          content="Control Tower"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6.5rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('control-tower')}
            className={`${navigation == 'control-tower' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/lucide_tower-control.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Control Tower
              </span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="Distributions"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6.5rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('distributions')}
            className={`${navigation == 'distributions' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/distributions.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Distributions
              </span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="Comparative"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6.45rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('comparative')}
            className={`${navigation == 'comparative' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/comparative.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Comparative
              </span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="Correlations"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6.35rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('correlations')}
            className={`${navigation == 'correlations' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/correlations.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Correlations
              </span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="Predictive "
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[5.85rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('predictive')}
            className={`${navigation == 'predictive' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/predictive.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Predictive{' '}
              </span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="Exploratory"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6.15rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('exploratory')}
            className={`${navigation == 'exploratory' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/exploratory.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Exploratory
              </span>
            )}
          </div>
        </Tooltip>
      </div>

      {/* Saved Dashboards */}
      <div
        className={`${!activateInteractiveM ? 'pointer-events-none opacity-40' : ''} ${
          isBigScreen ? 'mb-4' : 'mb-1.5'
        } flex flex-col`}>
        <Tooltip
          content="Saved dashboards"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[7.75rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('dashboards')}
            className={`${navigation == 'dashboards' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-5'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/dashboards.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Saved dashboards
              </span>
            )}
          </div>
        </Tooltip>
        <Tooltip
          content="File settings"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6.4rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('configuration')}
            className={`${navigation == 'configuration' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-5'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4`}>
            <img
              src="/icons/v3/configuration.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                File settings
              </span>
            )}
          </div>
        </Tooltip>
      </div>

      <div
        className={`${
          !activateInteractiveM ? 'opacity-70' : ''
        } border-b mx-3 my-1.5 border-[#788AA6]`}></div>

      {/* Resources */}
      <div
        className={`${!openMenu ? '' : 'invisible'} font-semibold ${
          isBigScreen ? 'text-sm' : 'text-xs'
        } ${isBigScreen ? 'pt-2' : 'pt-1.5'} pl-5`}>
        Resources
      </div>
      <div className="mt-1.5 flex flex-col mb-2">
        <Tooltip
          content="FAQ"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[4.65rem]'}`}
          menu={true}>
          <div
            onClick={() => onClickNavigation('faqs')}
            className={`${navigation == 'faqs' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4 ${trialExpired ? 'pointer-events-none opacity-50' : ''}`}>
            <img src="/icons/v3/faqs.svg" className={`${!isBigScreen ? 'h-[17px]' : ''}`} alt="" />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>FAQ</span>
            )}
          </div>
        </Tooltip>

        <Tooltip
          content="Contact us"
          direction="right"
          class={`${!openMenu ? 'hidden' : 'ml-[6rem]'}`}
          menu={true}>
          <div
            onClick={handleOpenEmail}
            className={`${navigation == 'contact_us' ? 'bg-[#788AA61F]' : ''} ${
              openMenu ? 'justify-center' : 'pl-11'
            } cursor-pointer hover:bg-[#788AA61F] ${
              isBigScreen ? 'py-3.5' : 'py-2'
            } flex items-center gap-4 ${trialExpired ? 'pointer-events-none opacity-50' : ''}`}>
            <img
              src="/icons/v3/contact-us.svg"
              className={`${!isBigScreen ? 'h-[17px]' : ''}`}
              alt=""
            />
            {!openMenu && (
              <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold`}>
                Contact us
              </span>
            )}
          </div>
        </Tooltip>

        {(accountPaidDashboard ||
          starterAccount ||
          trialAccountPaid ||
          freeAccount ||
          deactivateMenu) &&
          showStripeLink &&
          !accountLillyPaid &&
          !newLillyClaim && (
            <Tooltip
              content="Upgrade"
              direction="right"
              class={`${!openMenu ? 'hidden' : 'ml-[5.5rem]'}`}
              menu={true}>
              <div
                onClick={() => onClickNavigation('upgrade')}
                className={`${navigation == 'upgrade' ? 'bg-[#788AA61F]' : ''} ${
                  openMenu ? 'justify-center' : 'pl-10'
                } cursor-pointer hover:bg-[#788AA61F] ${
                  isBigScreen ? 'py-2.5' : 'py-1'
                } flex items-center 2xl:gap-2.5 gap-3`}>
                <img
                  src="/icons/v3/rocket.svg"
                  className={`${!isBigScreen ? 'h-[22px]' : ''}`}
                  alt=""
                />
                {!openMenu && (
                  <span className={`${isBigScreen ? 'text-sm' : 'text-xs'} font-semibold `}>
                    Upgrade
                  </span>
                )}
              </div>
            </Tooltip>
          )}
      </div>
    </div>
  );
};
